"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var DisplayedTags_1 = __importDefault(require("./DisplayedTags/DisplayedTags"));
var HoverStateUtils_1 = require("./HoverStateUtils");
exports.BASE_CLASS_NAME = "project-list-item";
var DeletedProjectListItem = (function (_super) {
    __extends(DeletedProjectListItem, _super);
    function DeletedProjectListItem(props) {
        var _this = _super.call(this, props) || this;
        _this.isHovered = false;
        _this.onMouseEnter = function () {
            if (_this.props.allowHoverState && (0, HoverStateUtils_1.viewportWidthAllowsHover)()) {
                _this.isHovered = true;
            }
        };
        _this.onMouseLeave = function () {
            _this.isHovered = false;
        };
        _this.handleRestoreClick = function (event) {
            event.stopPropagation();
            _this.props.onRestoreClick(event);
        };
        _this.onCheckboxClick = function (_toggleKey, event) {
            event.stopPropagation();
            if (!!_this.props.onCheckboxClick) {
                _this.props.onCheckboxClick(event);
            }
        };
        _this.deletedProjectStore = props.deletedProjectStore;
        return _this;
    }
    DeletedProjectListItem.prototype.render = function () {
        var _a;
        var _b = this.props, height = _b.height, marginBottom = _b.marginBottom, onDragStart = _b.onDragStart;
        return (react_1.default.createElement("div", { key: this.deletedProjectStore._id, className: (0, classnames_1.default)(exports.BASE_CLASS_NAME, "".concat(exports.BASE_CLASS_NAME, "--deleted"), (_a = {},
                _a["".concat(exports.BASE_CLASS_NAME, "--selected")] = this.props.isSelected,
                _a["".concat(exports.BASE_CLASS_NAME, "--selecting")] = this.props.isSelecting,
                _a["".concat(exports.BASE_CLASS_NAME, "--active")] = this.isHovered,
                _a["".concat(exports.BASE_CLASS_NAME, "--minimal")] = this.props.showMinimalActions,
                _a)), style: {
                height: height,
                marginBottom: marginBottom,
            }, onMouseDown: function (event) { return event.stopPropagation(); }, onClick: this.props.onClick, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, draggable: "true", onDragStart: onDragStart },
            react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__left-actions") },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(kaleidoscope_1.Checkbox, { item: { id: "@", value: "asd", label: "" }, labelHidden: true, toggleKey: "a", isSelected: this.props.isSelected, size: kaleidoscope_1.CheckboxSize.Medium, onChange: this.onCheckboxClick })),
                react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__main-text") },
                    react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__name") }, this.deletedProjectStore.name),
                    react_1.default.createElement(DisplayedTags_1.default, { tags: this.deletedProjectStore.tags }))),
            this.renderRightActions()));
    };
    DeletedProjectListItem.prototype.renderRightActions = function () {
        return (react_1.default.createElement("div", { className: "".concat(exports.BASE_CLASS_NAME, "__right-actions") },
            react_1.default.createElement(kaleidoscope_2.Button, { type: kaleidoscope_2.ButtonType.Secondary, size: kaleidoscope_2.ButtonSize.Small, onClick: this.handleRestoreClick, className: "pinned-actions" }, "Restore")));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], DeletedProjectListItem.prototype, "isHovered", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], DeletedProjectListItem.prototype, "onCheckboxClick", void 0);
    DeletedProjectListItem = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], DeletedProjectListItem);
    return DeletedProjectListItem;
}(react_1.default.Component));
exports.default = DeletedProjectListItem;
